// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* common non-tailwind css goes here */

html {
    font-feature-settings: "calt" 0;
}

.rbditem-enter {
    opacity: 0;
    transform: scale(0.9);
    min-height: 80px;
    padding: 8px;
}

.rbditem-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: opacity 300ms, transform 300ms;
    min-height: 80px;
    padding: 8px;
}

.rbditem-enter-done {
    min-height: 80px;
    padding: 8px;
}

.rbditem-exit {
    opacity: 1;
    min-height: 80px;
    padding: 8px;
}

.rbditem-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms, transform 300ms;
    min-height: 80px;
    padding: 8px;
}

.loader {
    border-top-color: #3498db;
    animation: spinner 1.5s linear infinite;
}

@keyframes spinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.dropDownMenuEl-enter {
    opacity: 0;
    transform: scale(0.95);
}

.dropDownMenuEl-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms, transform 300ms;
}

.dropDownMenuEl-enter-done {
    opacity: 1;
    transform: scale(1);
}

.dropDownMenuEl-exit {
    opacity: 1;
    transform: scale(1);
}

.dropDownMenuEl-exit-active {
    opacity: 0;
    transform: scale(0.95);
    transition: opacity 300ms, transform 300ms;
}
.dropDownMenuEl-exit-done {
    opacity: 0;
    transform: scale(0.95);
}

.profileMenuEl-enter {
    opacity: 0;
    transform: scale(0.95);
}

.profileMenuEl-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms, transform 300ms;
}

.profileMenuEl-enter-done {
    opacity: 1;
    transform: scale(1);
}

.profileMenuEl-exit {
    opacity: 1;
    transform: scale(1);
}

.profileMenuEl-exit-active {
    opacity: 0;
    transform: scale(0.95);
    transition: opacity 300ms, transform 300ms;
}
.profileMenuEl-exit-done {
    opacity: 0;
    transform: scale(0.95);
}

.inputbarebuttonleft:after {
    content: "";
    position: absolute;
    top: 0;
    left: -1px;
    width: 1px;
    height: 100%;
    background: #DDD;
}

article .entry-headline {

}

article.blog {
    font-size: 1.3rem;
    font-weight: 400;
}

article.blog a {
    color: #3498db;
}

article.blog h1 {
    
}

article.blog .entry-content h1{
    font-weight: 600;
    font-size: 1.25rem; /* 20px */
    line-height: 1.75rem; /* 28px */
    margin-bottom: 1rem;
    margin-top: 2.5rem;
}

article.blog h2 {
    font-size: 1.125em;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 0.5em;
}

article.blog h3 {
    font-size: 1.125em;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 0.5em;
}

article.blog h4 {
    font-size: 1em;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 0.5em;
}

article.blog ul {
    list-style: disc;
    margin-bottom: 1em;
    margin-top: 0;
    margin-left: 2rem;
}

article.blog p {
    margin-bottom: 1.2em;
}

article.blog p:last-child {
    margin-bottom: 0;
}

article.blog blockquote {
    border-left: 3px solid #3498db;
    font-style: italic;
    margin: 1.5em 0;
    padding: 0.5em 1em;
}

article.blog pre {
    margin-bottom: 1em;
}

article.blog code, article.blog pre>code {
    background: #c4b5fd;
    border-radius: 0.3em;
    font-size: 0.875em;
    padding: 0.3em;
}

article.blog .embed-responsive {
    flex: 1 1 auto;
    justify-content: center;
    display: flex;
}

article.blog img[src*='#left'] {
    float: left;
}
article.blog img[src*='#right'] {
    float: right;
}
article.blog img[src*='#center'] {
    display: block;
    margin: auto;
}
article.blog img[src*='#p-1'] {
    padding: 0.25rem;
}
article.blog img[src*='#p-1.5'] {
    padding: 0.375rem;
}
article.blog img[src*='#p-2'] {
    padding: 0.5rem;
}

article.blog img[src*='#90%'] {
    width: 90%;
}
article.blog img[src*='#80%'] {
    width: 80%;
}
article.blog img[src*='#70%'] {
    width: 70%;
}
article.blog img[src*='#60%'] {
    width: 60%;
}
article.blog img[src*='#50%'] {
    width: 50%;
}
article.blog img[src*='#40%'] {
    width: 40%;
}
article.blog img[src*='#30%'] {
    width: 30%;
}
article.blog img[src*='#20%'] {
    width: 20%;
}
article.blog img[src*='#10%'] {
    width: 10%;
}`, "",{"version":3,"sources":["webpack://./src/client/assets/css/common.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;IACI,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,0CAA0C;IAC1C,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,0CAA0C;IAC1C,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IAEzB,uCAAuC;AAC3C;;AAWA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,0CAA0C;AAC9C;AACA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,0CAA0C;AAC9C;AACA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,UAAU;IACV,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;AAEA;;AAEA;IACI,gBAAgB;IAChB,kBAAkB,EAAE,SAAS;IAC7B,oBAAoB,EAAE,SAAS;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd","sourcesContent":["/* common non-tailwind css goes here */\n\nhtml {\n    font-feature-settings: \"calt\" 0;\n}\n\n.rbditem-enter {\n    opacity: 0;\n    transform: scale(0.9);\n    min-height: 80px;\n    padding: 8px;\n}\n\n.rbditem-enter-active {\n    opacity: 1;\n    transform: translateX(0);\n    transition: opacity 300ms, transform 300ms;\n    min-height: 80px;\n    padding: 8px;\n}\n\n.rbditem-enter-done {\n    min-height: 80px;\n    padding: 8px;\n}\n\n.rbditem-exit {\n    opacity: 1;\n    min-height: 80px;\n    padding: 8px;\n}\n\n.rbditem-exit-active {\n    opacity: 0;\n    transform: scale(0.9);\n    transition: opacity 300ms, transform 300ms;\n    min-height: 80px;\n    padding: 8px;\n}\n\n.loader {\n    border-top-color: #3498db;\n    -webkit-animation: spinner 1.5s linear infinite;\n    animation: spinner 1.5s linear infinite;\n}\n\n@-webkit-keyframes spinner {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spinner {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.dropDownMenuEl-enter {\n    opacity: 0;\n    transform: scale(0.95);\n}\n\n.dropDownMenuEl-enter-active {\n    opacity: 1;\n    transform: scale(1);\n    transition: opacity 300ms, transform 300ms;\n}\n\n.dropDownMenuEl-enter-done {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.dropDownMenuEl-exit {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.dropDownMenuEl-exit-active {\n    opacity: 0;\n    transform: scale(0.95);\n    transition: opacity 300ms, transform 300ms;\n}\n.dropDownMenuEl-exit-done {\n    opacity: 0;\n    transform: scale(0.95);\n}\n\n.profileMenuEl-enter {\n    opacity: 0;\n    transform: scale(0.95);\n}\n\n.profileMenuEl-enter-active {\n    opacity: 1;\n    transform: scale(1);\n    transition: opacity 300ms, transform 300ms;\n}\n\n.profileMenuEl-enter-done {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.profileMenuEl-exit {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.profileMenuEl-exit-active {\n    opacity: 0;\n    transform: scale(0.95);\n    transition: opacity 300ms, transform 300ms;\n}\n.profileMenuEl-exit-done {\n    opacity: 0;\n    transform: scale(0.95);\n}\n\n.inputbarebuttonleft:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -1px;\n    width: 1px;\n    height: 100%;\n    background: #DDD;\n}\n\narticle .entry-headline {\n\n}\n\narticle.blog {\n    font-size: 1.3rem;\n    font-weight: 400;\n}\n\narticle.blog a {\n    color: #3498db;\n}\n\narticle.blog h1 {\n    \n}\n\narticle.blog .entry-content h1{\n    font-weight: 600;\n    font-size: 1.25rem; /* 20px */\n    line-height: 1.75rem; /* 28px */\n    margin-bottom: 1rem;\n    margin-top: 2.5rem;\n}\n\narticle.blog h2 {\n    font-size: 1.125em;\n    font-weight: 600;\n    line-height: 1.2;\n    margin-bottom: 0.5em;\n}\n\narticle.blog h3 {\n    font-size: 1.125em;\n    font-weight: 400;\n    line-height: 1.2;\n    margin-bottom: 0.5em;\n}\n\narticle.blog h4 {\n    font-size: 1em;\n    font-weight: 400;\n    line-height: 1.2;\n    margin-bottom: 0.5em;\n}\n\narticle.blog ul {\n    list-style: disc;\n    margin-bottom: 1em;\n    margin-top: 0;\n    margin-left: 2rem;\n}\n\narticle.blog p {\n    margin-bottom: 1.2em;\n}\n\narticle.blog p:last-child {\n    margin-bottom: 0;\n}\n\narticle.blog blockquote {\n    border-left: 3px solid #3498db;\n    font-style: italic;\n    margin: 1.5em 0;\n    padding: 0.5em 1em;\n}\n\narticle.blog pre {\n    margin-bottom: 1em;\n}\n\narticle.blog code, article.blog pre>code {\n    background: #c4b5fd;\n    border-radius: 0.3em;\n    font-size: 0.875em;\n    padding: 0.3em;\n}\n\narticle.blog .embed-responsive {\n    flex: 1 1 auto;\n    justify-content: center;\n    display: flex;\n}\n\narticle.blog img[src*='#left'] {\n    float: left;\n}\narticle.blog img[src*='#right'] {\n    float: right;\n}\narticle.blog img[src*='#center'] {\n    display: block;\n    margin: auto;\n}\narticle.blog img[src*='#p-1'] {\n    padding: 0.25rem;\n}\narticle.blog img[src*='#p-1.5'] {\n    padding: 0.375rem;\n}\narticle.blog img[src*='#p-2'] {\n    padding: 0.5rem;\n}\n\narticle.blog img[src*='#90%'] {\n    width: 90%;\n}\narticle.blog img[src*='#80%'] {\n    width: 80%;\n}\narticle.blog img[src*='#70%'] {\n    width: 70%;\n}\narticle.blog img[src*='#60%'] {\n    width: 60%;\n}\narticle.blog img[src*='#50%'] {\n    width: 50%;\n}\narticle.blog img[src*='#40%'] {\n    width: 40%;\n}\narticle.blog img[src*='#30%'] {\n    width: 30%;\n}\narticle.blog img[src*='#20%'] {\n    width: 20%;\n}\narticle.blog img[src*='#10%'] {\n    width: 10%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
